import { UserStatus } from '../enums/user';

export function isUserOffline(status?: string | UserStatus | null): boolean {
    if (status === undefined || status === null || status === '') {
        return false;
    }

    return status === UserStatus.OFFLINE;
}
